// The order of groups and fields inside groups is IMPORTANT. It will do the sorting of columns following the sequence from here.
// However, on UI they will be sorted alphabetically
export const seasonRosterExportFields = [
  {
    titleIntlKey: "seasonRoster.columns.competition.title",
    fields: ["competitionId", "competitionExternalId", "competitionName"],
  },
  {
    titleIntlKey: "seasonRoster.columns.season.title",
    fields: ["seasonId", "seasonExternalId", "seasonName"],
  },
  {
    titleIntlKey: "seasonRoster.columns.entity.title",
    fields: ["entityId", "entityExternalId", "entityName"],
  },
  {
    titleIntlKey: "seasonRoster.columns.person.title",
    fields: ["personId", "personExternalId", "personName"],
  },
  {
    titleIntlKey: "seasonRoster.columns.seasonRoster.title",
    fields: ["externalId", "bib", "position", "status"],
  },
  {
    titleIntlKey: "seasonRoster.columns.entityGroup.title",
    fields: ["entityGroupId", "entityGroupExternalId", "entityGroupName"],
  },
  {
    titleIntlKey: "seasonRoster.columns.conference.title",
    fields: ["conferenceId", "conferenceExternalId", "conferenceName"],
  },
  {
    titleIntlKey: "seasonRoster.columns.division.title",
    fields: ["divisionId", "divisionExternalId", "divisionName"],
  },
];

export const defaultSeasonRosterExportFieldNames = [
  "competitionName",
  "seasonName",
  "entityName",
  "personId",
  "personName",
  "bib",
  "position",
  "status",
];
